import { render, staticRenderFns } from "./AdministrationEditStaticContents.vue?vue&type=template&id=7f2e4345"
import script from "./AdministrationEditStaticContents.vue?vue&type=script&lang=js"
export * from "./AdministrationEditStaticContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports